export default {"src":"https://static.spiritory.com/_next/static/media/auth4.1324b09e.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};